import React from "react";
import { Button } from "reactstrap";

import { Header } from "../Components";
import useTutorialState from "../TutorialHooks";

import "../TutorialModalstyles.scss";
import "./FirstVideoStyles.scss";

const FirstVideoStep1 = ({}) => {
  const { activeStep, handleNext, showStep } = useTutorialState("first-video");

  if (showStep && activeStep === 1) {
    return (
      <div className="tutorial-modal">
        <div className="FirstVideoStyles">
          <div className="FirstVideoStep1">
            <Header showProgress={false} />

            <div className="description">
              Welcome to the <strong>My Videos folder</strong> under the <b>Videos
              Tab.</b> Here, you'll find all the videos you've added to your dashboard. 
            </div>

            <div className="footer-sec">
              <Button
                color="outline-primary"
                className="step-btn"
                onClick={() => handleNext()}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default FirstVideoStep1;
